import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

// Import your translation files here
import en from '../locales/en.json';
import jp from '../locales/jp.json';
import it from '../locales/it.json';
import es from '../locales/es.json';

class LanguageStore {
    language = '';
    translations = { en, jp, it, es };
    hydrated = false;
    
    constructor() {
        makeAutoObservable(this);
        this.initPersistence();
    }

    async initPersistence() {
        if (typeof window !== 'undefined') {
            const { isHydrated } = await makePersistable(this, {
                name: 'LangStore',
                properties: ['language'],
                storage: window.localStorage,
            });
            this.hydrated = isHydrated;
        }
    }

    setLanguage = (lang) => {
        this.language = lang;
    }

    getPageTranslations = (page) => {
        if (!this.hydrated) {
            return {};
        }
        
        const lang = this.language || 'en';
        return (this.translations && this.translations[lang] && this.translations[lang][page]) || {};
    }
}

export const languageStore = new LanguageStore();